/**
 * StructureMap — entity-centric corporate structure diagram.
 */

import { useMemo } from "react";
import type { PrimaryEntity, Group } from "../types";
import { buildEntityTree } from "./buildEntityTree";
import { EntityCard } from "./EntityCard";
import { SubsidiaryTree } from "./SubsidiaryTree";

export function StructureMap({
  primaryEntity,
  groups,
  onDocumentClick,
}: {
  primaryEntity: PrimaryEntity | null;
  groups: Group[];
  onDocumentClick?: (documentId: string) => void;
}) {
  const tree = useMemo(
    () => buildEntityTree(primaryEntity, groups),
    [primaryEntity, groups],
  );

  if (!tree) {
    return (
      <p className="py-8 text-center text-sm text-muted-foreground">
        No structure data to display.
      </p>
    );
  }

  return (
    <div className="flex flex-col px-2 pb-6">
      <EntityCard
        node={tree}
        defaultExpanded
        onDocumentClick={onDocumentClick}
      />
      {tree.children.length > 0 && (
        <SubsidiaryTree
          subsidiaries={tree.children}
          onDocumentClick={onDocumentClick}
        />
      )}
    </div>
  );
}
